import Vue from 'vue'

Vue.mixin({
    methods: {
        tableScrollTop() {
            if(this.$refs.table) {
                let tableScrollEle = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
                tableScrollEle && (tableScrollEle.scrollTop = 0)
            }
        }
    }
})